var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoMemberImg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 159,
    viewBox: "0 0 238 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M209.503 158.711H203.532L203.46 158.496L198.425 136.052H206.697L209.503 158.711ZM203.964 158.208H208.855L206.194 136.627H199.072L203.964 158.208Z",
    fill: "#8EABEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4839 158.711H28.5132L31.3187 136.052H39.5913L34.4839 158.711ZM29.1606 158.208H34.0523L38.8719 136.627H31.7503L29.1606 158.208Z",
    fill: "#8EABEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.031 158.711H187.061L186.989 158.496L181.953 136.052H190.226L193.031 158.711ZM187.564 158.208H192.456L189.794 136.627H182.672L187.564 158.208Z",
    fill: "#8EABEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.958 158.711H44.9873L47.7928 136.052H56.0654L50.958 158.711ZM45.6347 158.208H50.5264L55.3461 136.627H48.2244L45.6347 158.208Z",
    fill: "#8EABEE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6411 101.235H191.304L197.85 100.659L209.504 103.896L213.388 110.802L216.266 124.974L212.525 132.239L54.626 134.037L20.6003 127.995L21.7513 114.615L29.5923 103.465L38.872 98.8608L46.6411 101.235Z",
    fill: "#EAEFFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M213.39 110.802L209.505 103.896L197.852 100.659L191.306 101.235H46.6426L38.8735 98.8608L29.5938 103.465L24.4863 110.802H213.39Z",
    fill: "#CED9F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.97314 91.1638L22.6907 84.6176C24.4171 84.0421 25.4242 82.8911 25.9997 81.0208L32.1862 56.0591C32.9056 53.1816 34.704 51.599 37.5814 51.5271H47.005L42.1853 78.3592L25.4962 93.178H15.3532H7.58413L1.97314 91.1638Z",
    fill: "#CED9F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M236.121 91.1638L215.404 84.6176C213.677 84.0421 212.67 82.8911 212.095 81.0208L205.908 56.0591C205.189 53.1816 203.391 51.599 200.513 51.5271H191.09L195.909 78.3592L212.598 93.178H222.741H230.51L236.121 91.1638Z",
    fill: "#CED9F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3867 125.693V111.522C30.3867 109.507 31.25 107.709 33.0484 106.774L46.5723 104.76C49.0181 94.1131 41.321 84.4737 32.4009 85.265L12.0431 91.1638L11.1079 104.112L14.1292 114.183L21.6106 124.11L29.0919 126.844L30.3867 125.693Z",
    fill: "#CED9F2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M207.49 125.693V111.522C207.49 109.507 206.627 107.709 204.829 106.774L191.305 104.76C188.859 94.1131 196.556 84.4737 205.476 85.265L225.834 91.1638L228.064 97.8538L222.309 109.292C222.309 109.292 219.36 121.665 219.36 122.024C219.36 122.384 217.274 130.585 217.274 130.585H209.505L207.49 125.693Z",
    fill: "#CED9F2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M197.997 56.4188C197.061 53.2536 194.831 51.5271 191.379 51.5271H46.7155C43.2626 51.5271 41.0326 53.2536 40.0974 56.4188L32.688 87.7828L46.6436 104.832H191.307L205.478 87.7828L197.997 56.4188Z",
    fill: "#EAEFFC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M235.186 91.02H227.777C226.338 91.02 225.331 91.0919 224.612 92.9623L211.232 122.888C210.081 124.974 208.498 126.053 205.477 126.125H103.184H32.6151C29.5938 126.053 28.0112 124.902 26.8602 122.888L13.4082 92.9623C12.6888 91.02 11.6817 91.02 10.243 91.02H2.8336C1.25101 91.02 0.603585 92.2429 1.0352 93.4658L16.7892 135.62C17.6524 137.778 20.0982 139.793 23.4073 139.793H103.184H214.685C217.994 139.793 220.368 137.778 221.303 135.62L237.057 93.4658C237.417 92.171 236.769 91.02 235.186 91.02Z",
    fill: "#9EB3E3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M204.037 110.515H33.5491V111.09H204.037V110.515Z",
    fill: "#8EABEE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0294 86.3342L11.9321 91.0022L12.0924 91.5549L28.1897 86.887L28.0294 86.3342Z",
    fill: "#8EABEE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M209.57 86.2546L209.41 86.8071L225.504 91.4868L225.664 90.9342L209.57 86.2546Z",
    fill: "#8EABEE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M196.414 71.8131C204.039 69.727 220.225 73.8992 221.879 77.9277C223.534 81.9561 209.147 108.285 202.097 109.436C195.119 110.587 175.481 105.623 175.481 101.81C176.056 92.8184 188.789 73.9712 196.414 71.8131Z",
    fill: "#9EB3E3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M200.37 108.644C199.291 105.479 203.895 95.1204 208.787 87.4952C210.801 84.402 215.836 77.1364 219.649 76.7048L219.721 77.2084C217.203 77.4961 213.391 81.3087 209.218 87.783C203.895 96.1275 200.011 105.767 200.874 108.5L200.37 108.644Z",
    fill: "#8EABEE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6027 11.7954H8.91919V41.37L31.6027 41.9424V11.7954Z",
    fill: "#EBEBEB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30.11 12.8486H10.2654V39.6714L30.11 40.3399V12.8486Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6338 17.7205L13.4651 17.2214V35.9671H26.6338V17.7205Z",
    fill: "#EBEBEB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4651 35.9671L26.6338 26.3379L13.4651 17.2214V35.9671Z",
    fill: "#F5F5F5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8267 23.4264L65.8267 0.74292L36.252 0.742919L35.6797 23.4264L65.8267 23.4264Z",
    fill: "#EBEBEB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7734 21.9337L64.7734 2.08911L37.9507 2.08911L37.2822 21.9337L64.7734 21.9337Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9015 18.4578L60.4006 5.28906L41.6549 5.28906L41.6549 18.4578L59.9015 18.4578Z",
    fill: "#EBEBEB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6549 5.28906L51.2842 18.4578L60.4006 5.28906L41.6549 5.28906Z",
    fill: "#F5F5F5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M222.943 31.7067L222.943 9.02319L193.369 9.02319L192.796 31.7067L222.943 31.7067Z",
    fill: "#EBEBEB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M221.89 30.2142L221.89 10.3696L195.067 10.3696L194.399 30.2142L221.89 30.2142Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M217.018 26.738L217.517 13.5693L198.771 13.5693L198.771 26.738L217.018 26.738Z",
    fill: "#EBEBEB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M198.771 13.5693L208.401 26.738L217.517 13.5693L198.771 13.5693Z",
    fill: "#F5F5F5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M186.835 7.17529H164.152V36.7499L186.835 37.3223V7.17529Z",
    fill: "#EBEBEB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M185.343 8.22852H165.498V35.0513L185.343 35.7198V8.22852Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M181.866 13.1004L168.698 12.6013V31.347H181.866V13.1004Z",
    fill: "#EBEBEB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M168.698 31.347L181.866 21.7178L168.698 12.6013V31.347Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMemberImg);
export default __webpack_public_path__ + "static/media/no-member-img.00732139ec488f793e0219adcce28e09.svg";
export { ForwardRef as ReactComponent };